import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import NavigationUtil from 'utils/NavigationUtil';
import LeftNavigationAnalytics from 'utils/LeftNavigationAnalytics';
import templateHtml from 'templates/navigation/MenuItemChildView.html';

var Events = {
    NAV_ITEM_SELECTED: 'NAV_ITEM_SELECTED'
};

var MenuItemChildView = Backbone.View.extend({
    tagName: 'li',
    className: 'main-nav-menu-item',
    events: {
        'click .main-nav-link': 'onClick'
    },

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.active = args.active;
    },

    /**
     * Render the sidebar.
     */
    render: function() {
        var url = this.getURL();
        var label = this.getLabel();
        var customClasses = this.model.disabled ? 'read-only' : '';
        var actionItemClass = this.model.isActionItem ? 'click-action-item' : '';
        var html = this.template({
            title: label,
            url: url,
            customClasses,
            actionItemClass
        });
        this.$el.html(html);
        this.checkHighlight();

        Backbone.history.on('route', this.checkHighlight.bind(this));
        return this;
    },

    checkHighlight: function() {
        if (this.matchesUrl()) {
            this.trigger(Events.NAV_ITEM_SELECTED);
            this.highlight();
        }
    },

    getLabel: function() {
        if (this.model.label) {
            return this.model.label;
        }
        return Localizer.localize(this.model.title);
    },

    getURL: function() {
        if (this.model.url.indexOf('http') !== -1) {
            return this.model.url;
        }
        return NavigationUtil.url(this.model.url);
    },

    onClick: function(e) {
        if (!e.ctrlKey && !e.metaKey) {
            e.preventDefault();
        }

        e.stopPropagation();
        if (this.model.url.indexOf('http') !== -1) {
            window.location = this.model.url;
        } else {
            NavigationUtil.anchorTagHandler(e);
            LeftNavigationAnalytics.push(this.model.title);
            this.trigger(Events.NAV_ITEM_SELECTED);
            this.highlight(true);
        }
    },

    matchesUrl: function() {
        var pathname = window.location.pathname;
        // For the root path of admin which takes us to upload and highlights every time we have an admin entry selected.
        if (this.model.root) {
            return pathname === '/modern' + this.model.url;
        } else {
            var entryKeyword = this.model.urlKeyword || this.model.url;
            return pathname.indexOf(entryKeyword) !== -1;
        }
    },

    /**
     * Highlights the selected item.
     */
    highlight: function(active) {
        this.$el.addClass('active');
    }
});

MenuItemChildView.Events = Events;

export default MenuItemChildView;
